module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/school-desk/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/school-desk/wood.jpg
// module id = 182
// module chunks = 0